import React from "react";
import PropTypes from "prop-types";

const Flag = ({code}) => {
    if (!code) {
        return null
    }
    return <span className="f16"><span className={'country-flag ' + code.toLowerCase()}/></span>;
};

Flag.propTypes = {
    code: PropTypes.string.isRequired
};

export default Flag;
